export class Api {
    public API = {
        AUTH: {
            SIGNUP: 'user/sign-up',
            LOGIN: 'user/login',
            LOGOUT: 'user/logout',
            FORGOT_PASSWORD: 'user/forgot-password',
            CHANGE_PASSWORD: 'user/change-password',
            RESET_PASSWORD: 'user/reset-password',
            VERIFY_ACCOUNT: 'user/verify-account',
            RESEND_OTP: 'admin/counsellor-lrf/resend-otp'
        },
        COMMON: {
            ROLE_LIST: 'user/role/list',
            REGIONS_LIST: 'item/list-regions',
            STATES_LIST: 'item/list-states',
            CITIES_LIST: 'item/list-cities',
            NOTIFICATION_LIST: 'notification/list',
            NOTIFICATION_READ: 'notification/update-read-status',
            NOTIFICATION_MARK_ALL_READ: 'notification/mark-all-as-read'
        },
        USER: {
            USER_LIST: 'user/list',
            USER_EDIT: 'user/edit',
            USER_ADD: 'user/add',
            USER_DELETE: 'user/delete',
            USER_VIEW: 'user/view',
            USER_APPROVE_REJECT: 'user/approve-reject',
            EXPORT_USERS: 'user/list/export'
        },
        PO: {
            PO_LIST: 'item/purchase-order/list',
            PO_ADD_EDIT: 'item/purchase-order/add-edit',
            PO_DELETE: 'item/purchase-order/delete',
            PO_VIEW: 'item/purchase-order/view',
            PO_INBOUND: 'item/purchase-order/inbound',
            PO_VIEW_INBOUND: 'item/purchase-order/view-inbound',
            PO_EXPORT_INBOUND: 'item/inbound/export-list',
            CHANGE_STATUS: 'item/purchase-order/change-status',
            PO_IMPORT: 'item/purchase-order/bulk',
            PO_EXPORT: 'item/purchase-order/excel',
            PO_INBOUND_HISTORY: 'item/inbound/item-list',
            UPDATE_DELIVERY_DATE: 'item/inbound/edit-date',
            PO_EXPORT_INBOUND_NEW: 'item/inbound/excel',
            PO_INBOUND_SEND_REMINDER: 'item/purchase-order/send-notification'
        },
        INBOUND: {
            INBOUND_CREATE: 'item/purchase-order/create-inbound',
            INBOUND_LIST: 'item/purchase-order/inbound-list',
            INBOUND_EDIT: 'item/purchase-order/add-edit',
            INBOUND_VIEW: 'item/purchase-order/inbound-view',
            INBOUND_CHANGE_STATUS: 'item/purchase-order/inbound-change-status',
            INBOUND_CHANGE_STATUS_NEW: 'item/inbound/change-status',
            INBOUND_NEW_LIST: 'item/inbound/list',
            INBOUND_NEW_VIEW: 'item/inbound/view',
            INBOUND_ADD_EDIT: 'item/inbound/add-edit',
            INBOUND_UPDATE: 'item/inbound/update',
            GET_CLOSED_GRN: 'item/inbound/grn-details'
        },
        ROLE: {
            ROLE_LIST: 'user/role/list',
            ROLE_EDIT: 'user/role/add-edit',
            ROLE_DELETE: 'user/role/delete',
            ROLE_VIEW: 'user/role/view'
        },
        PERMISSION: {
            PERMISSION_ADD_EDIT: 'user/permission/add-edit',
            PERMISSION_DELETE: 'user/permission/delete',
            PERMISSION_VIEW: 'user/permission/view',
            PERMISSION_FUNCTIONS: 'user/permission/functions'
        },
        ITEM_TYPE_TEMPLATE: {
            ITEM_TYPE_TEMPLATE_LIST: 'item/item-type-template/list',
            ITEM_TYPE_TEMPLATE_ADD_EDIT: 'item/item-type-template/add-edit',
            ITEM_TYPE_TEMPLATE_DELETE: 'item/item-type-template/delete',
            ITEM_TYPE_TEMPLATE_VIEW: 'item/item-type-template/view',
            ITEM_TYPE_PO_LIST: 'item/po-item-types'
        },

        HELP_MANAGEMNT: {
            HELP_MANAGEMNT_CATEGORY_LIST: 'item/help-category/list',
            HELP_MANAGEMNT_CATEGORY_ADD_EDIT: 'item/help-category/add-edit',
            HELP_MANAGEMNT_CATEGORY_DELETE: 'item/help-category/delete',
            HELP_MANAGEMNT_CATEGORY_VIEW: 'item/help-category/view'
        },
        ITEMS: {
            ITEMS_LIST: 'item/list',
            ITEMS_ADD_EDIT: 'item/add-edit',
            ITEMS_DELETE: 'item/delete',
            ITEMS_VIEW: 'item/view',
            ITEMS_EXPORT: 'item/list/export',
            ASSEMBLE_ITEM_LIST: 'item/list-assemble-items',
            ASSEMBLE_ITEM_VIEW: 'item/view-assemble-items',
            CHEK_ASSEMBLE_ITEM_STOCK: 'item/check-assemble-stock',
            ADD_ASSEMBLE_REQUEST: 'item/add-assemble-item',
            UPDATE_ASSEMBLE_REQUEST_STATUS: 'item/assemble-items-status',
            ASSEMBLE_SERIALS_VERIFY: 'item/verify-serial-number-assemble',
            GET_AUTO_ALLOCATE_LOCATIONS:
                'item/auto-allocate-assemble-item-location',
            ITEMS_ASSEMBLED_EXPORT: 'item/list/assembled/export'
        },
        WAREHOUSE: {
            WAREHOUSE_LIST: 'item/warehouse/list',
            WAREHOUSE_LIST_PUBLIC: 'item/warehouse/list-public',
            WAREHOUSE_EDIT: 'item/warehouse/add-edit',
            WAREHOUSE_DELETE: 'item/warehouse/delete',
            WAREHOUSE_VIEW: 'item/warehouse/view',
            WAREHOUSE_EXPORT: 'item/warehouse/list/export'
        },
        WAREHOUSE_TAGGING_LOCATION: {
            WAREHOUSE_TAGGING_LOCATION_LIST:
                'item/warehouse-tagging-location/list',
            WAREHOUSE_TAGGING_LOCATION_ADD_EDIT:
                'item/warehouse-tagging-location/add-edit',
            WAREHOUSE_TAGGING_LOCATION_DELETE:
                'item/warehouse-tagging-location/delete',
            WAREHOUSE_TAGGING_LOCATION_VIEW:
                'item/warehouse-tagging-location/view',
            WAREHOUSE_TAGGING_LOCATION_EXPORT:
                'item/warehouse-tagging-location/list/export'
        },
        BRAND: {
            BRAND_LIST: 'item/brand/list',
            BRAND_EDIT: 'item/brand/add-edit',
            BRAND_DELETE: 'item/brand/delete',
            BRAND_VIEW: 'item/brand/view',
            BRAND_EXPORT: 'item/brand/list/export'
        },
        TRUCK_CAPACITY: {
            TRUCK_CAPACITY_LIST: 'item/truck-capacity/list',
            TRUCK_CAPACITY_EDIT: 'item/truck-capacity/add-edit',
            TRUCK_CAPACITY_DELETE: 'item/truck-capacity/delete',
            TRUCK_CAPACITY_VIEW: 'item/truck-capacity/view',
            TRUCK_CAPACITY_EXPORT: 'item/truck-capacity/list/export',
            TRUCK_CAPACITY_AUTO_ALLOCATE: 'item/truck-capacity/auto-allocate',
            TRUCK_CAPACITY_ALLOCATE_MANUALLY:
                'item/truck-capacity/calculate-manual-allocate'
        },
        ENTITY: {
            ENTITY_LIST: 'user/entity/list',
            ENTITY_EDIT: 'user/entity/add-edit',
            ENTITY_DELETE: 'user/entity/delete',
            ENTITY_VIEW: 'user/entity/view'
            // ENTITY_EXPORT:'item/brand/list/export',
        },
        EXCHANGE: {
            EXCHANGE_LIST: 'item/exchange/list',
            EXCHANGE_EDIT: 'item/exchange/add-edit',
            EXCHANGE_DELETE: 'item/exchange/delete',
            EXCHANGE_VIEW: 'item/exchange/view'
        },
        CONDITION: {
            CONDITION_LIST: 'item/condition/list',
            CONDITION_EDIT: 'item/condition/add-edit',
            CONDITION_DELETE: 'item/condition/delete',
            CONDITION_VIEW: 'item/condition/view',
            CONDITION_EXPORT: 'item/condition/list/export'
        },
        VENDOR_INVENTORY: {
            VENDOR_INVENTORY_LIST: 'item/myInventory/list',
            VENDOR_INVENTORY_LIST_FOR_SA: 'item/vendor-inventory/list',
            VENDOR_INVENTORY_EDIT: 'item/myInventory/add-edit',
            VENDOR_INVENTORY_DELETE: 'item/myInventory/delete',
            VENDOR_INVENTORY_VIEW: 'item/myInventory/view',
            VENDOR_INVENTORY_EXPORT: 'item/vendor-inventory/list/export',
            VENDOR_INVENTORY_HISTORY: 'item/vendor-inventory-history/list',
            VENDOR_INVENTORY_HISTORY_EXPORT:
                'item/vendor-inventory-history/list-export'
        },
        DASHBOARD_CATEGORY: {
            LIST: 'item/dashboard-category/list',
            ADD_EDIT: 'item/dashboard-category/add-edit',
            VIEW: 'item/dashboard-category/view',
            DELETE: 'item/dashboard-category/delete',
            REORDER: 'item/dashboard-category/reorder'
        },
        VENDOR_DASHBOARD_CATEGORY: {
            LIST: 'item/vendor-dashboard-category/list',
            ADD_EDIT: 'item/vendor-dashboard-category/add-edit',
            VIEW: 'item/vendor-dashboard-category/view',
            DELETE: 'item/vendor-dashboard-category/delete',
            REORDER: 'item/vendor-dashboard-category/reorder'
        },
        ORDERING_CATEGORY: {
            LIST: 'item/ordering-category/list',
            ADD_EDIT: 'item/ordering-category/add-edit',
            VIEW: 'item/ordering-category/view',
            DELETE: 'item/ordering-category/delete',
            REORDER: 'item/ordering-category/reorder'
        },
        CATEGORY: {
            CATEGORY_LIST: 'item/category/list',
            CATEGORY_EDIT: 'item/category/add-edit',
            CATEGORY_DELETE: 'item/category/delete',
            CATEGORY_VIEW: 'item/category/view'
        },
        SUB_CATEGORY: {
            SUB_CATEGORY_LIST: 'item/subcategory/list',
            SUB_CATEGORY_EDIT: 'item/subcategory/add-edit',
            SUB_CATEGORY_DELETE: 'item/subcategory/delete',
            SUB_CATEGORY_VIEW: 'item/subcategory/view'
        },
        CYCLE_COUNT: {
            CYCLE_COUNT_LIST: 'item/cycle-count/list',
            CYCLE_COUNT_ADD_COMPLETE: 'item/cycle-count/add-edit',
            CYCLE_COUNT_DELETE: 'item/cycle-count/delete',
            CYCLE_COUNT_VIEW: 'item/cycle-count/view',
            CYCLE_COUNT_EXPORT: 'item/cycle-count-export/list'
        },
        CMS: {
            CMS_LIST: 'item/cms/list',
            CMS_ADD_EDIT: 'item/cms/add-edit',
            CMS_DELETE: 'item/cms/delete',
            CMS_VIEW: 'item/cms/view'
        },
        GRN: {
            GRN_LIST: 'item/purchase-order/list-grns',
            GRN_ADD: 'item/purchase-order/add-grns',
            GRN_EDIT: 'item/purchase-order/edit-grns',
            GRN_VIEW: 'item/purchase-order/view-grns',
            GRN_AUTO_ALLOCATE: 'item/purchase-order/allocate-locations-grns',
            GRN_CRON: 'item/purchase-order/start-cron',
            GRN_EXPORT: 'item/purchase-order/list-grns/export',
            ADD_TESTED_SERIAL_NUMBER: 'item/purchase-order/add-testing-serial',
            ADD_DEFECTED_SERIAL_NUMBER:
                'item/purchase-order/add-defective-serial',
            CHECK_BIN_FITNESS: 'item/inventory/check-bin-capacity'
        },
        USER_ACTIVITIES: {
            USER_ACTIVITIES_LIST: 'audit/audit-management/list'
        },
        INVENTORY: {
            INVENTORY_LIST: 'item/inventory/list',
            INVENTORY_ADD_EDIT: 'item/inventory/add-edit',
            INVENTORY_DELETE: 'item/inventory/delete',
            INVENTORY_VIEW: 'item/inventory/view',
            INVENTORY_EXPORT: 'item/inventory-export/list',
            INVENTORY_EXPORT_AGING: 'item/inventory-aging-export/list',
            INVENTORY_UNIQ_ITEM_TYPE_LIST:
                'item/inventory/unique-item-types/list',
            INVENTORY_UNIQ_ITEM_LIST: 'item/inventory/unique-items/list',
            INVENTORY_ITEM_LIST: 'item/inventory/list-vendor-unique-items',
            INVENTORY_LOCATION_UPDATE: 'item/inventory/edit',
            INVENTORY_WARHOUSE: 'item/inventory/warehouse-list',
            INVENTORY_QUANTITY_UPDATE:
                'item/vendor-inventory-history/edit-quantity',
            INVENTORY_QUANTITY_UPDATE_HISTORY:
                'item/vendor-inventory-history/list-history-collection',
            INVENTORY_SEND_REMINDER: 'item/vendor-inventory/send-reminder',
            INVENTORY_UNIQ_ITEM_TRANSFER_LIST:
                'item/inventory/unique-items-transfer/list',
            INVENTORY_SWAP: 'item/swap',
            INVENTORY_UPLOAD_SERIAL_NUMBERS:
                'item/inventory/upload-serial-numbers',
            INVENTORY_SERIAL_NUMBER_SEARCH:
                'item/inventory/serial-number-search'
        },
        PROJECT: {
            PROJECT_LIST: 'item/project/list',
            PROJECT_ADD_EDIT: 'item/project/add-edit',
            PROJECT_DELETE: 'item/project/delete',
            PROJECT_VIEW: 'item/project/view',
            PROJECT_EXPORT: 'item/project/list/export',
            PROJECT_VENDOR: 'user/vendor-projects'
        },
        PROJECTWALLET: {
            PROJECT_WALLET_LIST: 'item/project-wallet/list',
            PROJECT_WALLET_WAREHOUSES_LIST:
                'item/project-wallet/list-warehouses',
            PROJECT_WALLET_VIEW: 'item/project-wallet/view',
            PROJECT_WALLET_LIST_PROJECT: 'item/project-wallet/list-projects',
            PROJECT_WALLET_EXPORT: 'item/project-wallet-excel/list'
        },
        PROJECT_TRANSFER_REQUEST: {
            PROJECT_TRANSFER_REQUEST_LIST: 'item/project-transfer/list',
            PROJECT_TRANSFER_REQUEST_VIEW: 'item/project-transfer/view',
            PROJECT_TRANSFER_REQUEST_VIEW_ADD_EDIT:
                'item/project-transfer/transfer-project-request',
            PROJECT_TRANSFER_REQUEST_DELETE: 'item/project-transfer/delete',
            PROJECT_TRANSFER_REQUEST_MANAGE_STATUS:
                'item/project-transfer/manage-status',
            PROJECT_TRANSFER_REQUEST_EXPORT:
                'item/project-transfer/list/export',
            PROJECT_TRANSFER_REQUEST_EXCEL_BY_ID:
                'item/project-transfer/excel-by-id'
        },
        BIN: {
            BIN_LIST: 'item/bin/list',
            BIN_ADD_EDIT: 'item/bin/add-edit',
            BIN_DELETE: 'item/bin/delete',
            BIN_VIEW: 'item/bin/view',
            BIN_EXPORT: 'item/bin/list/export'
        },
        WORK_ORDER_TYPE: {
            WORK_ORDER_TYPE_LIST: 'item/work-order-type/list',
            WORK_ORDER_TYPE_ADD_EDIT: 'item/work-order-type/add-edit',
            WORK_ORDER_TYPE_DELETE: 'item/work-order-type/delete',
            WORK_ORDER_TYPE_VIEW: 'item/work-order-type/view',
            WORK_ORDER_TYPE_EXPORT: 'item/work-order-type/list/export'
        },
        REPORT: {
            REPORT_LIST: 'item/report/list',
            REPORT_ADD_EDIT: 'item/report/add-edit',
            REPORT_DELETE: 'item/report/delete',
            REPORT_VIEW: 'item/report/view',
            REPORT_EXPORT: 'item/report/list/export',
            REPORT_PREVIEW: 'item/report/preview'
        },
        STATUS: {
            STATUS_LIST: 'item/status/list',
            STATUS_ADD_EDIT: 'item/status/add-edit',
            STATUS_DELETE: 'item/status/delete',
            STATUS_VIEW: 'item/status/view'
        },
        ITEM_TRANSFER: {
            ITEM_TRANSFER_LIST: 'item/item-transfer/list',
            ITEM_TRANSFER_ADD_EDIT: 'item/item-transfer/add-edit',
            ITEM_TRANSFER_DELETE: 'item/item-transfer/delete',
            ITEM_TRANSFER_VIEW: 'item/item-transfer/view',
            ITEM_TRANSFER_CHANGE_STATUS: 'item/item-transfer/change-status',
            ITEM_TRANSFER_EXPORT: 'item/item-transfer/list/export',
            ITEM_TRANSFER_GET_AUTO_SOURCE_LOCATION:
                'item/item-transfer/get-auto-source-location',
            GET_AVAILABLE_SERIAL_NUMBERS:
                'item/item-transfer/get-available-serial-numbers'
        },
        WORK_ORDER: {
            WORK_ORDER_LIST: 'item/work-order/list',
            WORK_ORDER_ADD_EDIT: 'item/work-order/add-edit',
            WORK_ORDER_DELETE: 'item/work-order/delete',
            WORK_ORDER_VIEW: 'item/work-order/view',
            WORK_ORDER_EXPORT: 'item/work-order/list/export',
            WORK_ORDER_STATUS_CHANGE: 'item/work-order/approve-reject'
        },

        WORK_ORDER_REQUEST: {
            WORK_ORDER_LIST: 'item/work-order-request/list',
            WORK_ORDER_ADD_EDIT: 'item/work-order-request/create',
            WORK_ORDER_VIEW: 'item/work-order-request/view',
            WORK_ORDER_APPROVE_REJECT: 'item/work-order-request/approve-reject',
            CHECK_ITEM_STOCK:
                'item/work-order-request/check-project-item-stock',
            WORK_ORDER_CHANGE_STATUS: 'item/work-order-request/change-status',
            CALCULATE_QUANTITY: 'item/work-order-request/calculate-quantity',
            WORK_ORDER_EXPORT: 'item/work-order-request/excel',
            EXCEL_BY_ID: 'item/work-order-request/excel-by-id'
        },
        COLLECTION_NOTE: {
            COLLECTION_NOTE_LIST: 'item/collection-note/list',
            COLLECTION_NOTE_APPROVE_REJECT:
                'item/collection-note/approve-reject',
            COLLECTION_NOTE_VIEW: 'item/collection-note/view',
            COLLECTION_NOTE_EDIT: 'item/collection-note/add-edit',
            COLLECTION_NOTE_COLLECT: 'item/collection-note/collect',
            COLLECTION_NOTE_EXPORT: 'item/collection-note-excel/list',
            COLLECTION_NOTE_AUTO_ALLOCATION:
                'item/collection-note/auto-allocate',
            COLLECTION_NOTE_SINGLE_DATA:
                'item/collection-note/collect-single-item',
            COLLECTION_NOTE_UPDATE_SERIAL_NUMBERS:
                'item/collection-note/update-serial-numbers',
            COLLECTION_NOTE_UPDATE_SUPERVISOR:
                'item/collection-note/update-supervisor',
            COLLECTION_NOTE_UPDATE_STATUS: 'item/collection-note/update-status',
            COLLECTION_NOTE_VERIFY_SERIALS:
                'item/collection-note/verify-serial',
            COLLECTION_NOTE_SEND_REMINDER:
                'item/collection-note/send-notification',
            COLLECTION_NOTE_CANCEL: 'item/collection-note/cancel'
        },
        ADJUSTMENT: {
            ADJUSTMENT_LIST: 'item/adjustment/list',
            ADJUSTMENT_CREATE: 'item/adjustment/create',
            ADJUSTMENT_APPROVE_REJECT: 'item/adjustment/approve-reject',
            ADJUSTMENT_EXPORT: 'item/adjustment/list/export'
        },
        RACK: {
            RACK_LIST: 'item/rack/list',
            RACK_ADD_EDIT: 'item/rack/add-edit',
            RACK_DELETE: 'item/rack/delete',
            RACK_VIEW: 'item/rack/view',
            RACK_EXPORT: 'item/rack/list/export'
        },
        SHELF: {
            SHELF_LIST: 'item/shelf/list',
            SHELF_ADD_EDIT: 'item/shelf/add-edit',
            SHELF_DELETE: 'item/shelf/delete',
            SHELF_VIEW: 'item/shelf/view',
            SHELF_EXPORT: 'item/shelf/list/export'
        },
        COLUMN: {
            COLUMN_LIST: 'item/column/list',
            COLUMN_VIEW: 'item/column/view',
            COLUMN_ADD_EDIT: 'item/column/add-edit',
            COLUMN_EXPORT: 'item/column/list/export'
        },
        DOCK: {
            DOCK_LIST: 'item/dock/list',
            DOCK_ADD_EDIT: 'item/dock/add-edit',
            DOCK_DELETE: 'item/dock/delete',
            DOCK_VIEW: 'item/dock/view',
            DOCK_EXPORT: 'item/dock/list/export'
        },
        WEIGHT: {
            WEIGHT_LIST: 'item/weight-type/list',
            WEIGHT_EDIT: 'item/weight-type/add-edit',
            WEIGHT_DELETE: 'item/weight-type/delete',
            WEIGHT_VIEW: 'item/weight-type/view'
        },
        UNIT_OF_MEASURE: {
            UNIT_OF_MEASURE_LIST: 'item/unit-of-measure/list',
            UNIT_OF_MEASURE_ADD_EDIT: 'item/unit-of-measure/add-edit',
            UNIT_OF_MEASURE_DELETE: 'item/unit-of-measure/delete',
            UNIT_OF_MEASURE_VIEW: 'item/unit-of-measure/view'
        },
        ITEM_TYPE: {
            ITEM_TYPE_LIST: 'item/item-type/list',
            ITEM_TYPE_ADD_EDIT: 'item/item-type/add-edit',
            ITEM_TYPE_DELETE: 'item/item-type/delete',
            ITEM_TYPE_VIEW: 'item/item-type/view',
            ITEM_UNIQUE_ITEM_TYPES: 'item/unique-item-types'
        },
        DIMENSION_TYPE: {
            DIMENSION_TYPE_LIST: 'item/dimension-type/list',
            DIMENSION_TYPE_ADD_EDIT: 'item/dimension-type/add-edit',
            DIMENSION_TYPE_DELETE: 'item/dimension-type/delete',
            DIMENSION_TYPE_VIEW: 'item/dimension-type/view'
        },
        UPLOAD_FILE: {
            UPLOAD: 'media/upload'
        },
        LIST_MASTER: {
            LIST_MASTER: 'item/list-master'
        },
        NOTIFICATION: {
            LIST: 'item/notification/list',
            ENABLE_DISABLE: 'item/notification/toggle'
        },

        DASHBOARD: {
            DASHBOARD_LIST: 'user/dashboard',
            DASHBOARD_USER_LIST: 'user/dashboard-user',
            DASHBOARD_USER_STATS: 'user/dashboard/stats',
            ITEM_DASHBOARD_DATA: 'item/dashboard-item',
            ITEM_DASHBOARD_OTHER_TYPES_PO: 'item/dashboard-item/other-types-po'
        },
        SWAPPED_ITEMS: {
            LIST: 'item/inventory/history/list'
        },

        APPOINTMENT: {
            APPOINTMENT_LIST: 'admin/counsellor-appointment/list',
            APPOINTMENT_VIEW: 'admin/counsellor-appointment/view',
            APPOINTMENT_EXPORT: 'admin/counsellor-appointment/export',
            APPOINTMENT_CANCEL:
                'admin/counsellor-appointment/cancel-appointment',
            APPOINTMENT_UPDATE:
                'admin/counsellor-appointment/update-appointment-status',
            // Time Slot Setting
            SLOT_LIST: 'admin/counsellor-appointment/list-slot-settings',
            SLOT_UPDATE: 'admin/counsellor-appointment/update-slot-setting',
            SLOT_Add: 'admin/counsellor-appointment/add-appointment',
            SLOT_DETAIL:
                'admin/counsellor-appointment/view-appointment-details',
            SLOT_AVAILABLE: 'admin/counsellor-appointment/get-available-dates'
        },
        VIDEO_CALL: {
            JOIN_CALL: 'v1/agora/generate-token-counsellor',
            CALL_STATUS: 'v1/agora/call-status-counsellor'
        }
    }
}
